import { Icon } from "@iconify/react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logoTagline, logoText } from "../../constants";
import { useAuth } from "../../hooks";
import styles from "./Sidebar.module.css";

const Sidebar = () => {
  const menu = [
    {
      title: "Dashboard (Reports)",
      icon: "material-symbols:dashboard-outline",
      link: "/",
    },
    {
      title: "Agents",
      icon: "mdi:face-agent",
      link: "/agents",
    },
    {
      title: "Leads",
      icon: "mdi:account-funnel-outline",
      link: "/leads",
    },
    {
      title: "Customers",
      icon: "mdi:hand-heart-outline",
      link: "/customers",
    },
    {
      title: "Aurus Group",
      icon: "mdi:company",
      link: "/aurus-group",
    },
    {
      title: "Project Owners",
      icon: "mdi:briefcase-account-outline",
      link: "/project-owners",
    },
    {
      title: "Project Listing",
      icon: "majesticons:list-box-line",
      link: "/project-listing",
    },
    {
      title: "Bookings",
      icon: "material-symbols:book-outline",
      link: "/bookings",
    },
    {
      title: "Credits",
      icon: "wpf:banknotes",
      link: "/credits",
    },
    {
      title: "Debits",
      icon: "mingcute:bill-2-line",
      link: "/debits",
    },
    {
      title: "Company T&C",
      icon: "mynaui:asterisk-waves",
      link: "/company-tc",
    },
    {
      title: "Coupons",
      icon: "mdi:coupon-outline",
      link: "/coupons",
    },
    {
      title: "Testimonials & News",
      icon: "material-symbols:reviews-outline",
      link: `/testimonials-news`,
    },
    {
      title: "Canceled Plots Request",
      icon: "tabler:cancel",
      link: "/canceled-plot-request",
    },
  ];

  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const { success, error } = await logout();
    if (error) {
      toast.error(error);
    } else {
      toast.success(success);
    }

    navigate("/login");
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo_wrapper}>
        <div className={styles.logo}>{logoText}</div>
        <div className={styles.logo_tagline}>{logoTagline}</div>
      </div>
      <hr className="divider" />
      <nav className={styles.menu}>
        {menu.map((item, index) => (
          <NavLink
            key={index}
            to={item.link}
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.link_active}` : styles.link)}
          >
            <Icon icon={item.icon} inline />
            {item.title}
          </NavLink>
        ))}
      </nav>
      <div className={styles.logout_wrapper}>
        <button onClick={handleLogout} className={styles.logout_btn}>
          <Icon icon="mdi:logout" inline />
          Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
